namespace TabAurous.Inventory {
    export interface SKUGenerationRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        VoucherNo?: string;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: SKUStockItemRow[];
        PrintingDetails?: SKUItemsRow[];
        Pieces?: number;
        NoofSKU?: number;
        LineNoSelected?: number;
        ProductIdSelected?: number;
        AttributeIdSelected?: number;
        SKUSelected?: string;
        Markup?: number;
        GenerateSKU?: string;
        Username?: string;
        PostingDate?: string;
        IsPosted?: boolean;
    }

    export namespace SKUGenerationRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.SKUGeneration';
        export const deletePermission = 'Inventory:SKUGeneration:Delete';
        export const insertPermission = 'Inventory:SKUGeneration:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:SKUGeneration:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            PrintingDetails = "PrintingDetails",
            Pieces = "Pieces",
            NoofSKU = "NoofSKU",
            LineNoSelected = "LineNoSelected",
            ProductIdSelected = "ProductIdSelected",
            AttributeIdSelected = "AttributeIdSelected",
            SKUSelected = "SKUSelected",
            Markup = "Markup",
            GenerateSKU = "GenerateSKU",
            Username = "Username",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted"
        }
    }
}
